export enum EvaluationStatus {
  FINISHED = 'FINISHED',
  IN_PROGRESS = 'IN_PROGRESS',
  ON_HOLD = 'ON_HOLD',
  READY = 'READY',
  UNFINISHED_EVALUATION = 'UNFINISHED_EVALUATION',
  WAIT_EVALUATION = 'WAIT_EVALUATION',
}